module.exports = __webpack_public_path__ + "img/34.57536a72.png";